<template>
    <div class="quantum-max__wrapper">
        <p class="quantum-max__title">Finish Quantum Max'ın <br>
        <span>yeni ActivBlu teknolojisiyle tanışma zamanı</span></p>
        <p class="quantum-max__content">Adınızı, soyadınızı ve adres bilgilerinizi<br>
<span>rbturkeyfinish@rb.com</span> adresine gönderin,<br>
sürpriz Finish ürünleri kapınıza gelsin.</p>
        <div class="quantum-max__images">
            <a href="https://www.finish.com.tr" target="_blank" class="quantum-max__logo">
                <img src="../assets/img/icons/finish-logo@2x.png">
            </a>
            <a href="/" class="quantum-max__logo">
                <img src="../assets/img/icons/ys-logo.png">
            </a>
        </div>
    </div>
</template>
<script>
    import EventBus from "../main";

    export default {
        name: "QuantumMax",
        mounted() {
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'subPage');
        }
    }
</script>
<style lang="scss">
    /*body {
        background-image: url('../../src/assets/backgrounds/quantum_background.jpg');
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        background-position: center;
    }*/
    .quantum-max__wrapper {
        padding: 0 40px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        transform: translateY(-5%);

    }
    .quantum-max__title {
        font-size: 2.916vw;
        color: white;
        text-align: center;
        
        @media only screen and (max-device-width: 768px) {
            font-size: 6.916vw;
        }
    }
    .quantum-max__title span{
        font-weight: 600;
    }
    .quantum-max__content {
        font-size: 1.562vw;
        color: white;
        text-align: center;
        @media only screen and (max-device-width: 768px) {
            font-size: 4.562vw;
        }
    }
    .quantum-max__content  span{
        font-weight: bold;
    }
    .quantum-max__images {
        display: flex;
        align-items: flex-end;
        justify-content: center;
    }
    .quantum-max__logo {
        width: 6.8vw;
        margin: 0 4.2%;
        @media only screen and (max-device-width: 768px) {
            width: 20vw;
        }
    }
    .quantum-max__logo:nth-child(2) {
        width: 10vw;
        @media only screen and (max-device-width: 768px) {
            width: 30vw;
        }
    }
    .quantum-max__logo img {
        width: 100%;
    }
</style>